import { render } from "./_settings.vue?vue&type=template&id=7a5dd32f"
import script from "./_settings.vue?vue&type=script&lang=js"
export * from "./_settings.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./_settings.vue?vue&type=style&index=0&id=7a5dd32f&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script